const GOOGLE_ADS_CONVERSION_ID = 'AW-17815380048'
const BUY_NOW_CONVERSION_LABEL = 'wQuaCM7u4N4bENDAhK9C'
const ADD_TO_CART_CONVERSION_LABEL = 'Q_4sCNTu4N4bENDAhK9C'
const SIGN_UP_CONVERSION_LABEL = 'x2SnCNfu4N4bENDAhK9C'
const LANDING_PAGE_VIEW_LABEL = 'dcVxCNHu4N4bENDAhK9C'
const ADD_TO_CART_DEDUPE_WINDOW_MS = 10_000

export type ConversionSource = 'canvas' | 'boards'
type AddToCartKey = ConversionSource | 'unknown'
const lastAddToCartBySource: Partial<Record<AddToCartKey, number>> = {}

export const trackBuyNowConversion = (
  transactionId: string,
  source?: ConversionSource
): boolean => {
  if (typeof window.gtag !== 'function') return false

  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${BUY_NOW_CONVERSION_LABEL}`,
    transaction_id: transactionId,
    source,
  })

  return true
}

export const trackAddToCartConversion = (
  source?: ConversionSource
): boolean => {
  if (typeof window.gtag !== 'function') return false
  const sourceKey: AddToCartKey = source ?? 'unknown'
  const now = Date.now()
  const lastTrackedAt = lastAddToCartBySource[sourceKey]

  // Drop rapid duplicate add-to-cart conversions from repeated clicks.
  if (
    typeof lastTrackedAt === 'number' &&
    now - lastTrackedAt < ADD_TO_CART_DEDUPE_WINDOW_MS
  ) {
    return false
  }

  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${ADD_TO_CART_CONVERSION_LABEL}`,
    source,
  })
  lastAddToCartBySource[sourceKey] = now

  return true
}

export const trackSignUpConversion = (): boolean => {
  if (typeof window.gtag !== 'function') return false

  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${SIGN_UP_CONVERSION_LABEL}`,
  })

  return true
}

export const trackLandingPageViewConversion = (): boolean => {
  if (typeof window.gtag !== 'function') return false

  window.gtag('event', 'conversion', {
    send_to: `${GOOGLE_ADS_CONVERSION_ID}/${LANDING_PAGE_VIEW_LABEL}`,
  })

  return true
}
